"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ControlReportsModule = /** @class */ (function () {
    function ControlReportsModule() {
    }
    return ControlReportsModule;
}());
exports.ControlReportsModule = ControlReportsModule;
